import { apiClientForOutSourcing } from '../../../utils/lib/apiClient';
import { loadingState, loadingText } from '../../../states/loadingState';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { useCallback } from 'react';
import { AddressInfoType } from '../../../types';

export const useAddAddress = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const addToAddress = useCallback(
    async (postData: AddressInfoType) => {
      setLoadingAnimation(true);
      setLoadingText('登録中...');
      const reqBody = {
        postData,
      };
      try {
        const res = await apiClientForOutSourcing.post(
          `/address/to-address`,
          reqBody
        );

        const data = res.data;
        const status = res.status;
        return { data, status };
        //   return 0;
      } catch (e) {
        window.alert('エラーが発生しました' + e);
        return null;
      } finally {
        setLoadingAnimation(false);
        setLoadingText('');
      }
    },
    [loadingState, loadingText]
  );
  const addCcAddress = useCallback(
    async (postData: AddressInfoType) => {
      setLoadingAnimation(true);
      setLoadingText('登録中...');
      const reqBody = {
        postData,
      };
      try {
        const res = await apiClientForOutSourcing.post(
          `/address/cc-address`,
          reqBody
        );

        const data = res.data;
        const status = res.status;
        return { data, status };
        //   return 0;
      } catch (e) {
        window.alert('エラーが発生しました' + e);
        return null;
      } finally {
        setLoadingAnimation(false);
        setLoadingText('');
      }
    },
    [loadingState, loadingText]
  );

  return { addToAddress, addCcAddress };
};
